import * as React from 'react';
import * as style from './style.css';

export const TitleSection = ({ children }: React.PropsWithChildren) => {
  return <div className={style['section']}>{children}</div>;
};
